import { Box, Typography, Paper } from '@mui/material';

function Home() {
  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Welcome to SRU Alumni
      </Typography>
      
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography>
          This is the LIFF application for SRU Alumni members.
        </Typography>
      </Paper>
    </Box>
  );
}

export default Home;
